<div class="flex flex-col w-full" *ngIf="editSec">
  
  <fuse-alert class="mt-2 -mb-4 mx-10" *ngIf="showAlert" [appearance]="'soft'" [showIcon]="false" [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
  </fuse-alert>

  <div class="flex flex-col w-full px-6 mt-2 my-4 cntntBgrnd">
    <div class="relative flex flex-col   flex-0 ng-tns-c266-4 ">
     
      <form nz-form [formGroup]="timingEditForm">
        
          <div formArrayName="editFormDta">
          
              <div class="grid grid-cols-6 font-semibold bg-gray-100 text-center py-2 my-4 mt-0 gap-8 w-full">
                <div class="flex flex-col">
                </div>
                <div class="flex flex-col text-blue-600">
                  <h1>First Session</h1>
                </div>
                <div class="flex flex-col">
                </div>
                <div class="flex flex-col text-blue-600">
                  <h1>Second Session</h1>
                </div>
                <div class="flex flex-col">
                </div>
              </div>
            
              <div class="grid grid-cols-6 font-medium text-sm text-center my-2 mt-0 gap-8 w-full">
                <div class="flex flex-col">
                  <h1>Day</h1>
                </div>
                <div class="flex flex-col">
                  <h1>Start Time</h1>
                </div>
                <div class="flex flex-col">
                  <h1>End Time</h1>
                </div>
                <div class="flex flex-col">
                  <h1>Secondary Start Time</h1>
                </div>
                <div class="flex flex-col">
                  <h1>Secondary End Time</h1>
                </div>
                <div class="flex flex-col">
                  <h1>Mark as holiday</h1>
                </div>
              </div>
            
            <div  *ngFor="let r of timingEditForm.get('editFormDta').controls; let i = index">
              <div [formGroupName]="i">
                <div class="grid grid-cols-6 gap-6 mb-3 w-full">
                  <div class="flex flex-col m-auto text-center font-medium">
                    <input type="text" formControlName="enty_ky" matInput readonly style="display: none;" />
                    <input type="text" formControlName="wk_dy_id" matInput readonly style="display: none;" />
                    <input type="text" formControlName="wk_dy_nm" matInput readonly />
                  </div>
                  <div class="flex flex-col">
                    <mat-form-field class="example-full-width">
                    <input type="text" formControlName="strt_tm" matInput [ngxMatTimepicker]="strt_tm" format="12"
                        readonly/>
                      <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    </mat-form-field>
                    <ngx-mat-timepicker #strt_tm></ngx-mat-timepicker>
                  </div>
                  <div class="flex flex-col">
                    <mat-form-field class="example-full-width">
                      <input type="text" formControlName="end_tm" matInput [ngxMatTimepicker]="end_tm" format="12"
                        readonly />
                      <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    </mat-form-field>
                    <ngx-mat-timepicker #end_tm></ngx-mat-timepicker>
                  </div>
                  <div class="flex flex-col">
                    <mat-form-field class="example-full-width">
                      <input type="text" formControlName="scnd_strt_tm" matInput [ngxMatTimepicker]="scnd_strt_tm"
                        format="12" readonly />
                      <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    </mat-form-field>
                    <ngx-mat-timepicker #scnd_strt_tm></ngx-mat-timepicker>
                  </div>
                  <div class="flex flex-col">
                    <mat-form-field class="example-full-width">
                      <input type="text" formControlName="scnd_end_tm" matInput [ngxMatTimepicker]="scnd_end_tm"
                        format="12" readonly />
                      <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                    </mat-form-field>
                    <ngx-mat-timepicker #scnd_end_tm></ngx-mat-timepicker>
                  </div>
                  <div class="flex flex-col mx-auto	">
                    <mat-slide-toggle (change)='updateHoliday(i,r)' color="primary" formControlName="hldy_in" >
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>
          </div>
      
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 mb-4 sm:mt-6">
          <div class="-ml-2">
          </div>
          <div class="flex items-center mt-4 sm:mt-0">
            <mat-slide-toggle (change)='update24hrs($event)' color="primary" [checked]="checked">
            </mat-slide-toggle> 24Hrs Open
            <button class="ml-auto sm:ml-0" mat-button (click)="Close()">
              Cancel
            </button>
            <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="sendEdt()"> Save
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>

</div>